import React from 'react'
import { Box, Heading } from '@traefiklabs/faency'
import { StyledLink } from '../../components/Link'
import SideNavbarLayout from '../../layouts/SideNavbarLayout'

import ReactMarkdown from 'react-markdown'
import termsContent from './terms-content.md'

const markdownRenderers = {
  // eslint-disable-next-line react/display-name
  link: ({ ...props }) => <StyledLink {...props} target="_blank" />,
}

const TermsPage = () => (
  <>
    <Heading as="h1" size={5} mb={2}>
      Terms
    </Heading>
    <Box mb={4}>
      <ReactMarkdown source={termsContent} renderers={markdownRenderers} />
    </Box>
  </>
)

TermsPage.getLayout = (page) => <SideNavbarLayout title={'Terms'}>{page}</SideNavbarLayout>

export default TermsPage
